import {getGlossary} from "../services/request-manager";


export const getCollectGlossary = () => {
    return getGlossary()
}